import api from './api';

// Fetch centers from database
export const getCentersFromDB = async () => {
  try {
    const response = await api.post('/CampChannel/GetCenterForRetreat', {
      organization_Id: 3
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching centers:', error);
    throw error;
  }
};

// Fetch camps/retreats for a center from database
export const getCampsForCenter = async (centerId) => {
  try {
    const response = await api.post('/CampChannel/GetCamp', {
      camp_Center_Id: centerId,
      status: 'Y'
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching camps:', error);
    throw error;
  }
};

const retreatService = {
  async getCenters(countryDesc = 'USA') {
    try {
      const payload = {
        Country_Desc: countryDesc
      };
      const response = await api.post('/CampChannel/GetCenterForRetreat', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching centers:', error);
      throw error;
    }
  },

  async getCentersForCamp(countryDesc = 'USA') {
    try {
      const payload = {
        Country_Desc: countryDesc
      };
      const response = await api.post('/CampChannel/GetCenterForCamp', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching centers for camp:', error);
      throw error;
    }
  },

  async getCampsByCenter(centerId) {
    try {
      const payload = {
        camp_Id: 0,
        center_Id: centerId,
        camp_Name: "",
        camp_Description: "",
        camp_Fee: 0,
        camp_Date_To: "2026-12-31T00:00:00.000Z",
        camp_Date_From: "2026-01-01T00:00:00.000Z",
        camp_Image_Url: "",
        camp_Type: "R",
        app_Id: 4,
        organization_Id: 0,
        country_Desc: "USA"
      };
      const response = await api.post('/CampChannel/GetCamp', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching camps:', error);
      throw error;
    }
  },

  async getUnregisteredStudents(userId, campId) {
    try {
      const payload = {
        User_Id: userId,
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/FetchUnRegisteredStudents', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching unregistered students:', error);
      throw error;
    }
  },

  async getRegisteredStudents(userId, campId) {
    try {
      const payload = {
        User_Id: userId,
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/FetchRegisteredStudents', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching registered students:', error);
      throw error;
    }
  },

  async addStudent(studentData) {
    try {
      const response = await api.post('/CampChannel/AddRetreatCampStudents', studentData);
      return response.data;
    } catch (error) {
      console.error('Error adding student:', error);
      throw error;
    }
  },

  async addRetreatRegistration(registrationData) {
    try {
      const response = await api.post('/CampChannel/AddRetreatRegistration', registrationData);
      return response.data;
    } catch (error) {
      console.error('Error adding retreat registration:', error);
      throw error;
    }
  },

  async addRetreatRegistrationDetail(detailData) {
    try {
      const response = await api.post('/CampChannel/AddRetreatRegistrationDetail', detailData);
      return response.data;
    } catch (error) {
      console.error('Error adding retreat registration detail:', error);
      throw error;
    }
  },

  async getAttendeeDetails(campId, studentId) {
    try {
      const payload = {
        Camp_Id: campId,
        Student_Id: studentId
      };
      const response = await api.post('/CampChannel/FetchAttendeeDetails', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching attendee details:', error);
      throw error;
    }
  },

  async getUnpaidAttendees(userId, campId) {
    try {
      // EXACT Swagger schema: user_Id and camp_Id (snake_case)
      const payload = {
        user_Id: userId,
        camp_Id: campId
      };
      console.log('GetUPaidAttendees payload:', payload);
      const response = await api.post('/CampChannel/GetUPaidAttendees', payload);
      console.log('GetUPaidAttendees response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching unpaid attendees:', error);
      throw error;
    }
  },

  async getRetreatCalculation(userId, campId) {
    try {
      const payload = {
        User_id: userId,
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/GetRetreatCalculation', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching retreat calculation:', error);
      throw error;
    }
  },

  async getAccommodationFeeAndCampDate(campId) {
    try {
      const payload = {
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/GetAccommodationFeeAndCampDate', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching accommodation fee and camp date:', error);
      throw error;
    }
  },

  async updatePaymentStatus(paymentData) {
    try {
      const response = await api.post('/CampChannel/UpdatePaymentStatus', paymentData);
      return response.data;
    } catch (error) {
      console.error('Error updating payment status:', error);
      throw error;
    }
  },

  async getEnrolledStudents(userId, campId) {
    try {
      const payload = {
        User_Id: userId,
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/GetRetreatEnrolledStudents', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching enrolled students:', error);
      throw error;
    }
  },

  async visitRegisteredStudent(campId, studentId) {
    try {
      const payload = {
        Camp_Id: campId,
        Student_Id: studentId
      };
      const response = await api.post('/CampChannel/VisitRegisteredStudent', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching registered student visits:', error);
      throw error;
    }
  },

  async deleteVisitorRecord(campId, studentId, registrationDetailsId) {
    try {
      const payload = {
        Camp_Id: campId,
        Student_Id: studentId,
        Retreat_Registration_Details_Id: registrationDetailsId
      };
      const response = await api.post('/CampChannel/DeleteRecordOfvisiters', payload);
      return response.data;
    } catch (error) {
      console.error('Error deleting visitor record:', error);
      throw error;
    }
  },

  async getUserDetail(userId) {
    try {
      const payload = {
        User_Id: userId
      };
      const response = await api.post('/CampChannel/UserDetail', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching user detail:', error);
      throw error;
    }
  },

  async getUserRegistrationDetails(userId) {
    try {
      const payload = {
        User_Id: userId
      };
      const response = await api.post('/CampChannel/GetUserRegistrationDetails', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching user registration details:', error);
      throw error;
    }
  },

  async updateUserDetail(userData) {
    try {
      const response = await api.post('/CampChannel/UpdateUserDetail', userData);
      return response.data;
    } catch (error) {
      console.error('Error updating user detail:', error);
      throw error;
    }
  },

  async getFinancialRecordByCamp(campId) {
    try {
      const payload = {
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/GetRecordByCamp', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching financial record by camp:', error);
      throw error;
    }
  },

  async getCampRecordByYear(year) {
    try {
      const payload = {
        Year: year
      };
      const response = await api.post('/CampChannel/GetCampRecordByYr', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching camp record by year:', error);
      throw error;
    }
  },

  async getCampAttendeeDetails(campId) {
    try {
      const payload = {
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/GetCampAttendeeDetails', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching camp attendee details:', error);
      throw error;
    }
  },

  async getAttendanceMatrix(campId) {
    try {
      const payload = {
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/GetMatrixDataOfAttendace', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching attendance matrix:', error);
      throw error;
    }
  },

  async getEnrolledStudentForAttendance(campId) {
    try {
      const payload = {
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/GetEnrolledStudentForAttendance', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching enrolled students for attendance:', error);
      throw error;
    }
  },

  async addCampAttendanceCheckIn(attendanceData) {
    try {
      const response = await api.post('/CampChannel/AddCampAttendanceIn', attendanceData);
      return response.data;
    } catch (error) {
      console.error('Error adding camp attendance check-in:', error);
      throw error;
    }
  },

  async getEnrolledStudentForCheckout(campId) {
    try {
      const payload = {
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/GetEnrolledStudentForAttendanceForCheckout', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching enrolled students for checkout:', error);
      throw error;
    }
  },

  async updateCampAttendanceCheckOut(attendanceData) {
    try {
      const response = await api.post('/CampChannel/UpdateCampAttendanceIn', attendanceData);
      return response.data;
    } catch (error) {
      console.error('Error updating camp attendance checkout:', error);
      throw error;
    }
  },

  async getAttendanceReport(campId) {
    try {
      const payload = {
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/GetAttendanceReport', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching attendance report:', error);
      throw error;
    }
  },

  async getCampStudentMedical(campId) {
    try {
      const payload = {
        Camp_Id: campId
      };
      const response = await api.post('/CampChannel/GetCampStudentMedical', payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching camp student medical:', error);
      throw error;
    }
  },

  async addVolunteerWaiver(waiverData) {
    try {
      const response = await api.post('/CampChannel/AddVolunteerWaiver', waiverData);
      return response.data;
    } catch (error) {
      console.error('Error adding volunteer waiver:', error);
      throw error;
    }
  },

  async getWaiverTypes() {
    try {
      const response = await api.get('/CampChannel/GetWaiver');
      return response.data;
    } catch (error) {
      console.error('Error fetching waiver types:', error);
      throw error;
    }
  },

  async addWaiverRequest(requestData) {
    try {
      const response = await api.post('/CampChannel/AddWaiverRequest', requestData);
      return response.data;
    } catch (error) {
      console.error('Error adding waiver request:', error);
      throw error;
    }
  },

  async getWaiverRequests() {
    try {
      const response = await api.get('/CampChannel/GetWaiverRequest');
      return response.data;
    } catch (error) {
      console.error('Error fetching waiver requests:', error);
      throw error;
    }
  },

  async getWaiverRequestReminders() {
    try {
      const response = await api.get('/CampChannel/GethWaiverRequestReminder');
      return response.data;
    } catch (error) {
      console.error('Error fetching waiver request reminders:', error);
      throw error;
    }
  }
};

export default retreatService;
